import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Supervisor() {

  const [supervisors, setSupervisors] = useState([]);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    employeeId: "",
    zone: ""
  });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setSupervisors([
      ...supervisors,
      form
    ]);

    setForm({
      name: "",
      phone: "",
      email: "",
      employeeId: "",
      zone: ""
    });
  };

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div className="main-content">

        <h1>Supervisors</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Supervisor Name"
            value={form.name}
            onChange={handleChange}
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
          />

          <input
            type="text"
            name="employeeId"
            placeholder="Employee ID"
            value={form.employeeId}
            onChange={handleChange}
          />

          <input
            type="text"
            name="zone"
            placeholder="Assigned Zone"
            value={form.zone}
            onChange={handleChange}
          />

          <button type="submit">
            Add Supervisor
          </button>

        </form>

      </div>

    </div>
  );
}

export default Supervisor;